import { useHref, useLinkClickHandler, useLocation } from 'react-router-dom';
import { withImpersonation } from '../../utils/impersonation';

/**
 * `href` and `onClick` for rendering an in-app route as a real `<a>` (exposed to assistive
 * technology as a link) that still navigates client-side and keeps the `?email=`
 * impersonation parameter. Modified clicks (Ctrl/Shift/middle) fall through to the browser.
 */
export const useImpersonationLink = (path: string) => {
  const { search } = useLocation();
  const to = withImpersonation(path, search);
  const href = useHref(to);
  const onClick = useLinkClickHandler<HTMLAnchorElement>(to);
  return { href, onClick };
};
